import {AccountId} from '@raison/types';
import {RsnDialog} from '@raison/ui-kit';
import {useInfiniteQuery} from '@tanstack/react-query';
import React, {Fragment, useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import RsnLoader from '~/shared/legacy_presentational-components/Rsn/Loader/RsnLoader';
import {useTransactionsHistoryOptions} from '../../api/useTransactionsHistoryOptions';
import {TransactionSchema} from '../../model/TransactionSchema';
import {PendingTransactItem} from '../PendingTransactItem/PendingTransactItem';
import scss from './PendingTransactModal.module.scss';

export const PendingTransactModal = ({
    fetchNextPage,
    orders,
    loading,
    isOpen,
    onClose,
    isListExhausted,
}: {
    orders: TransactionSchema[];
    fetchNextPage: () => void;
    loading: boolean;
    isOpen: boolean;
    onClose: () => void;
    isListExhausted: boolean;
}) => {
    const {ref, inView} = useInView();

    useEffect(() => {
        if (!isListExhausted && inView) {
            fetchNextPage();
        }
    }, [inView]);

    return (
        <RsnDialog.Controller isOpen={isOpen} onClose={onClose}>
            <RsnDialog.Window placement='bottom'>
                <RsnDialog.LeftHeader text='Transactions in progress' />
                <RsnDialog.Body>
                    {orders.length > 0 ? (
                        <Fragment>
                            {orders.slice(0, -1).map(order => (
                                <PendingTransactItem key={order.id} order={order} />
                            ))}
                            {orders.at(-1) && <PendingTransactItem ref={ref} order={orders.at(-1)!} />}
                        </Fragment>
                    ) : (
                        <div className={scss.emptyList}>It was fast, all transactions were already completed!</div>
                    )}
                    {loading && (
                        <div className={scss.justifyCenter}>
                            <RsnLoader color='#9DA0A6' className={scss.loader} />
                        </div>
                    )}
                </RsnDialog.Body>
            </RsnDialog.Window>
        </RsnDialog.Controller>
    );
};

export const BlockingCryptoTransactsContainer = ({
    from,
    isOpen,
    onClose,
}: {
    from: AccountId;
    isOpen: boolean;
    onClose: () => void;
}) => {
    const {
        data: {orders = [], total = 0} = {},
        isLoading,
        fetchNextPage,
    } = useInfiniteQuery({
        ...useTransactionsHistoryOptions({wallet: [from], status: ['pending']}),
    });

    const isListExhausted = orders.length === total;

    return (
        <PendingTransactModal
            orders={orders}
            fetchNextPage={fetchNextPage}
            loading={isLoading}
            isOpen={isOpen}
            onClose={onClose}
            isListExhausted={isListExhausted}
        />
    );
};
